import { render, staticRenderFns } from "./sn-head-photo.vue?vue&type=template&id=214395ae"
import script from "./sn-head-photo.vue?vue&type=script&lang=js"
export * from "./sn-head-photo.vue?vue&type=script&lang=js"
import style0 from "./sn-head-photo.vue?vue&type=style&index=0&id=214395ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports